import { flatten } from 'lodash-es';
const flattenSections = (item) => {
    const childSections = item.sections?.map((subSection) => ([subSection, ...flattenSections(subSection)])) || [];
    return flatten(childSections);
};
export default flattenSections;
//# sourceMappingURL=flattenSections.js.map